import { createRequestTypes } from 'common/websocket-redux';

export const GET_EMPLOYEE_SPENDING_ACCOUNTS =
  'employee/GET_EMPLOYEE_SPENDING_ACCOUNTS';
export const FETCH_EMPLOYEE_SPENDING_ACCOUNTS = createRequestTypes(
  'service/FETCH_EMPLOYEE_SPENDING_ACCOUNTS',
);
export const RESET_EMPLOYEE_SPENDING_ACCOUNTS =
  'employee/RESET_EMPLOYEE_SPENDING_ACCOUNTS';
